import { useState } from 'react';

// Membership toggling for filter and row-expansion state. RecentStatusPanel
// carried three near-identical copies of this before it moved here.
export const useToggleSet = <T>(initial: T[] = []) => {
  const [values, setValues] = useState<Set<T>>(new Set(initial));

  const toggle = (value: T) =>
    setValues((previous) => {
      const next = new Set(previous);
      if (next.has(value)) {
        next.delete(value);
      } else {
        next.add(value);
      }
      return next;
    });

  return {
    values,
    toggle,
    clear: () => setValues(new Set()),
    replace: (next: T[]) => setValues(new Set(next))
  };
};
